import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../../../store";
import { getCanonicalTitle } from "../../../../../common/util/Incentives/IncentiveRegistry";
import { useGetBronzeGroupCountsQuery } from "../../../../../services/GroupManagementOverview/groupManagementOverviewAPI";
import { ActionCard } from "../../ActionCard/ActionCard";
import type { ActionCardRow } from "../../ActionCard/ActionCard";
import type { ActionCardRecord } from "../../../../../services/GroupManagementOverview/groupManagementOverviewAPI.types";
import { ActionCardError } from "../../ActionCard/ActionCardError/ActionCardError";
import defaultContent from "../../../../../content/groupManagement";
import { ROUTE_PATHS } from "../../../../../common/enums/routing-enums";
import { storedLocale } from "../../../../Authentication/util";
import TEALIUM from "../../../../../common/enums/tealium-enums";
import { track } from "../../../../../common/util/tealium";
import { CardComponentProps } from "../ActionCenter";

export const BronzeGroupTrackingCard = ({ enabled }: CardComponentProps) => {
  const { t } = useTranslation(["groupManagement"]);
  const { user } = useAppSelector((state) => state.boot);
  const { data, isError, isLoading, refetch } = useGetBronzeGroupCountsQuery(
    { abo: user.abo, aff: user.aff, locale: storedLocale() },
    { skip: !enabled },
  );

  const hasError = isError || !!data?.error;
  const noDataAvailable = Number(data?.totalCount) === 0 && !isLoading;

  const transformRows = () => {
    return (
      data?.counts?.map((record: ActionCardRecord) => ({
        kpiValue: record.countFormatted,
        kpiName: t(record.key, defaultContent[record.key] ?? record.key),
        trend: record.trend,
      })) ?? []
    );
  };

  const handleTracking = () => {
    track(
      TEALIUM.U_TAG_METHOD.LINK,
      TEALIUM.EVENT_NAME.CLICK_ACTION,
      TEALIUM.CATEGORY.GROUP_MANAGEMENT,
      "bronze_tracking",
      "",
      "bronze_group_tracking",
    );
  };

  const cardTitle = getCanonicalTitle({ id: "bronzeGroupTracking" }, t, {});

  return (
    <ActionCard
      title={cardTitle}
      rows={!noDataAvailable ? transformRows() : []}
      to={ROUTE_PATHS.BRONZE_GROUP_TRACKING}
      disabled={!enabled}
      isLoading={isLoading}
      onClickTracking={handleTracking}
      testId="bronze-group-tracking-card"
    >
      {hasError && <ActionCardError onRetry={refetch} />}
      {noDataAvailable && (
        <span className="action-card__no-data">{t("noDataForCriteria", defaultContent.noDataForCriteria)}</span>
      )}
    </ActionCard>
  );
};
